<template>
    <div class="components-field-box">
        <div class="box-title">
            <img :src="props.data.icon" alt="" />
            <div class="text">{{props.data.title }}</div> 
        </div>
        <div class="box-module">
            <div class="module-item">
                <div class="module-top">
                    <div class="module-title">{{ props.data.szaqInfo?.title }}</div>
                    <!-- <van-button icon="down" type="primary" size="mini" @click="szaqDownLoad()">下载领域说明</van-button> -->
                </div>
                <van-collapse v-model="szaqKey" accordion>
                    <van-collapse-item v-for="item in props.data.szaqInfo?.list" :name="item.title">
                        <template #title>
                            <div class="item-title">{{item.title}}</div>
                        </template>
                        <div class="item-desc" v-html="item.desc"></div>
                    </van-collapse-item>
                </van-collapse>
            </div>
            <div class="module-item">
                <div class="module-top">
                    <div class="module-title">{{ props.data.rgznInfo?.title }}</div>
                    <!-- <van-button icon="down" type="primary" size="mini" @click="rgznDownLoad()">下载领域说明</van-button> -->
                </div>
                <van-collapse v-model="rgznKey" accordion>
                    <van-collapse-item v-for="item in props.data.rgznInfo?.list" :name="item.title">
                        <template #title>
                            <div class="item-title">{{item.title}}</div>
                        </template>
                        <div class="item-desc" v-html="item.desc"></div>
                    </van-collapse-item>
                </van-collapse>
            </div>
            <div class="module-btn">
                <van-button icon="down" type="primary" @click="downLoad()">完整领域说明</van-button>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue';

const szaqKey = ref('');
const rgznKey = ref('');

const props = defineProps({
  data: {
    type: Object,
    default: () => {
      return {}
    }
  }
})

const downLoad = () => {
    window.open(props.data.szaqInfo.downLoadUrl)
}
</script>

<style lang="scss" scoped>
.components-field-box{
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-top: 56px;
    .box-title{
        display: flex;
        align-items: center;
        img{
            width: 22px;
            height: 22px;
        }
        .text{
            color: rgb(38, 38, 38);
            font-family: 阿里巴巴普惠体 2.0;
            font-size: 20px;
            font-weight: 700;
            letter-spacing: 0px;
            margin-left: 12px;
        }
    }
    .box-module{
        width: 100%;
        display: flex;
        flex-direction: column;
        margin-top: 24px;
        border-radius: 8px;
        background: rgb(255, 255, 255);
        padding: 20px 8px;
        .module-item{
            width: 100%;
            margin-bottom: 28px;
            .module-top{
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 0 16px;
                margin-bottom: 12px;
                .module-title{
                    color: rgb(30, 89, 191);
                    font-family: 阿里巴巴普惠体 2.0;
                    font-size: 16px;
                    font-weight: 700;
                    line-height: 20px;
                    letter-spacing: 0px;
                }
            }
            :deep(.van-cell__right-icon){
                font-size: 14px;
            }
            .item-desc{
                color: rgb(38, 38, 38);
                font-family: 阿里巴巴普惠体 2;
                font-size: 12px;
                font-weight: 300;
                line-height: 22px;
                letter-spacing: 0px;
                text-align: justify;
            }
            &:last-child{
                margin-bottom: 0px;
            }
        }
    }
    .module-btn{
        width: 100%;
        display: flex;
        justify-content: center;
        :deep(.van-button--primary) {
            background: linear-gradient(180deg, rgb(88, 142, 235), rgb(30, 89, 191) 100%);
            border: none;
            height: 36px;
        }
    }
}
</style>
